import React, { Children } from "react";
import { Table } from "react-bootstrap";

import classes from "./Table.module.css";

function Newcommontable({ style, Children }: { style?: any; Children: any }) {
  return (
    <div style={style} className={`${classes.table_container} scroll_inner`}>
      <Table className={classes.maintableSec} style={{ margin: "0" }}>
        {Children}
      </Table>
    </div>
  );
}

export default Newcommontable;
